export const GET_ARTICLES_CATEGORIES_ASYNC = "GET_ARTICLES_CATEGORIES_ASYNC";
export const GET_ARTICLES_CATEGORIES_SUCCESS = "GET_ARTICLES_CATEGORIES_SUCCESS";
export const GET_ARTICLES_LIST_ASYNC = "GET_ARTICLES_LIST_ASYNC";
export const GET_ARTICLES_LIST_SUCCESS = "GET_ARTICLES_LIST_SUCCESS";



// WEBPACK FOOTER //
// ./src/HomeCare/constants.js